import React from 'react';
import PropTypes from 'prop-types';

export default function TableStatusUI(props) {
  const { type, data, notCleared } = props;
  const statusCaseObj = {
    status: {
      paid: { text: '| Cleared', customClass: 'green' },
      generated: {
        text: notCleared ? '| Yet to clear' : '| Cleared',
        customClass: notCleared ? 'red' : 'green',
      },
      carried_over: {
        text: notCleared ? '| Carried over' : '| Cleared',
        customClass: notCleared ? 'orange' : 'green',
      },
      failed: { text: '| Failed', customClass: 'red' },
      Created: { text: '| Created', customClass: 'green' },
      Deleted: { text: '| Deleted', customClass: 'red' },
    },
    kycStatus: {
      0: { text: 'Kyc approved', customClass: 'green' },
      1: { text: 'Kyc pending', customClass: 'red' },
      2: { text: 'Kyc declined', customClass: 'orange' },
      3: { text: 'Kyc not initiated', customClass: 'red' },
    },
  };
  return (
    <div>
      <div className={`status ${statusCaseObj?.[type]?.[data]?.customClass}`}>
        {statusCaseObj?.[type]?.[data]?.text}
      </div>
    </div>
  );
}

TableStatusUI.propTypes = {
  type: PropTypes.string,
  data: PropTypes.string,
  notCleared: PropTypes.bool,
};
